import { render, staticRenderFns } from "./pages2_1.vue?vue&type=template&id=c641a8fe&scoped=true&"
import script from "./pages2_1.vue?vue&type=script&lang=js&"
export * from "./pages2_1.vue?vue&type=script&lang=js&"
import style0 from "./pages2_1.vue?vue&type=style&index=0&id=c641a8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c641a8fe",
  null
  
)

export default component.exports